import { InformationType, POPULATION_TYPE } from "../models";
import { apiCall } from "./ApiResult.model";
import axios from "axios";
import { ItemSummary } from "../models/entity-summary.model";
import { SharedState } from "../state";

export const objectsSummary = apiCall<
  { ids: string[]; type: POPULATION_TYPE | "clusters" },
  ItemSummary[]
>(
  "summary",
  async (p) => {
    let summaryType = "clusters";
    let reqType = "events";
    let label: InformationType;
    switch (p.type) {
      case POPULATION_TYPE.LABEL:
        reqType = "info-types";
        summaryType = "label";
        label = SharedState.allInfoTypes.value[p.ids[0]];
        break;
      case POPULATION_TYPE.EVENT:
        reqType = "events";
        summaryType = "event";
        break;
      case POPULATION_TYPE.CONTACT:
      case POPULATION_TYPE.FILE:
      case POPULATION_TYPE.FOLDER:
      case POPULATION_TYPE.EMPLOYEE:
      case POPULATION_TYPE.ORGANIZATION:
      case POPULATION_TYPE.PRIVATE_EMAIL:
        if (p.type === POPULATION_TYPE.FILE) {
          label = SharedState.allInfoTypes.value[p.ids[0]];
        }
        reqType = "objects";
        summaryType = p.type === POPULATION_TYPE.FILE ? "file" : "entity";
        break;
      default:
        reqType = "clusters";
    }
    const res = await axios.post(
      `/extproxy/summary/${reqType}?resultType=raw_summary`,
      [...p.ids]
    );

    let objects = res.data;
    if (p.type === POPULATION_TYPE.FILE) {
      objects = objects.map((file: any) => {
        const informationTypes = (file.informationTypes || [])
          .filter((f: any) => SharedState.allInfoTypes.value[f.id])
          .map((f: any) => {
            const label = SharedState.allInfoTypes.value[f.id];
            return {
              ...f,
              ...label,
            };
          });
        return {
          ...file,
          informationTypes:
            informationTypes.length > 0
              ? informationTypes
              : [SharedState.default_label.value],
        };
      });
    } else if (p.type === POPULATION_TYPE.LABEL) {
      objects = objects.map((l: any) => {
        return {
          ...l,
          description: l.description || label.desc,
          name: l.name || label.name,
        };
      });
    }

    return {
      success: true,
      value: objects.map((item: any) => ({ ...item, type: summaryType })),
    };
  },
  {
    memo: {
      lastResultsCount: 2,
      getKey: ({ ids, type }) => ids[0] + "_" + type,
    },
  }
);
